import React, {FunctionComponent} from 'react';

import {Loading} from '../components';

interface PreviewImageProps {
  image: string | null | undefined;
  loading: boolean;
}

const PreviewImage: FunctionComponent<PreviewImageProps> = ({
  image,
  loading,
}: PreviewImageProps) => {
  if (loading) {
    return <Loading className="view-preview-image"/>;
  } else if (!image) {
    return null;
  }

  return (
    <div className="tableau-form__preview-image">
      <img src={"data:image/png;base64," + image} alt="View Image"/>
    </div>
  );
};

export default PreviewImage;
